var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 172.618 498.669 C 180.279 495.273 185.646 487.427 185.646 478.293 L 185.646 418.358 C 185.646 416.172 185.818 413.895 186.088 411.587 C 185.937 411.632 185.798 411.665 185.646 411.698 C 185.646 411.698 153.317 411.698 146.852 411.698 C 130.687 411.698 116.678 405.038 110.214 391.718 C 102.671 377.291 99.438 352.873 80.04 339.554 C 76.808 337.334 78.963 334.003 85.429 334.003 C 91.893 335.115 105.902 343.994 114.523 356.202 C 124.223 368.413 133.921 378.401 151.162 378.401 C 177.963 378.401 192.328 377.013 200.97 372.241 C 211.035 356.825 224.968 345.103 239.527 345.103 L 239.527 344.827 C 178.449 342.807 139.427 321.895 121.259 289.609 C 81.765 290.075 47.377 294.104 27.755 297.457 C 27.13 293.827 26.589 290.175 26.127 286.501 C 45.491 283.217 78.316 279.321 116.054 278.577 C 114.848 275.513 113.802 272.371 112.918 269.154 C 75.083 267.178 42.432 268.72 24.695 270.231 C 24.479 266.546 24.188 262.871 24.144 259.142 C 41.914 257.645 73.682 256.146 110.546 257.91 C 109.697 252.361 109.148 246.691 109.148 240.785 C 109.148 221.916 115.612 201.937 127.464 185.29 C 122.078 166.421 114.535 126.465 129.621 112.036 C 158.717 112.036 179.191 126.465 188.89 135.343 C 207.198 127.563 227.673 123.123 250.303 123.123 C 272.932 123.123 293.408 127.563 310.65 135.333 C 320.348 126.454 340.823 112.026 369.918 112.026 C 386.082 127.563 377.462 167.52 372.073 185.277 C 383.927 201.927 390.392 220.796 389.314 240.773 C 389.314 246.144 388.829 251.329 388.129 256.412 C 425.834 254.502 458.464 256.036 476.536 257.544 C 476.515 261.285 476.182 264.936 475.986 268.632 C 457.981 267.102 424.532 265.524 385.909 267.645 C 384.95 271.374 383.786 275.002 382.408 278.52 C 420.619 279.032 454.23 282.839 474.52 286.168 C 474.058 289.854 473.519 293.504 472.894 297.123 C 452.29 293.727 417.17 289.755 377.213 289.554 C 359.271 321.497 320.962 342.329 261.078 344.76 L 261.078 345.103 C 289.097 345.103 314.959 388.389 314.959 418.358 L 314.959 478.293 C 314.959 487.427 320.326 495.273 327.988 498.669 C 426.708 465.017 498.153 369.122 498.153 256.313 C 498.153 115.555 386.977 1.035 250.303 1.035 C 113.629 1.035 2.452 115.555 2.452 256.313 C 2.452 369.122 73.899 465.017 172.618 498.669 Z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.0ac3404423dc0d8f1dcaadbf0926f427.svg";
export { ForwardRef as ReactComponent };